import { StudentInjuryNoteNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: StudentInjuryNoteNameFragment) {
	return instance.id;
}

export const fieldSetLabels = {
	actionTaken: "Subsequent actions (select all relevant actions taken)",
};

export const fieldLabels = {
	incidentTime: "When did this incident happen?",
	incidentLocation: "Where did this incident happen?",
	wereOtherStudentsCauseOfInjury: "Did other students cause this injury?",
	causeOfInjury: "What was the cause of the injury?",
	medicalAttentionProvided: "Describe medical attention provided",
	adultWhoProvidedMedicalAttention: "Name of attending adult (who provided medical attention)",
	isActionTakenHomeroomTeachersNotified: "Homeroom teachers notified",
	isActionTakenParentNotifiedByPortal: "Parent notified by portal",
	isActionTakenParentNotifiedByPhone: "Parent notified by phone",
	isActionTakenParentsRequestedToCollectStudent: "Parents requested to collect student",
	isActionTakenParentNotificationNotNecessary: "Parent notification not necessary",
	isActionTakenOther: "Other",
	actionTakenOther: "Describe",
};
